import { GetPresignedDocumentUploadURLForRespondentsRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDocumentUploadUrlForRespondentsRPCClientImpl";
import { GetRespondentDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/getRespondentDetailsRPCClientImpl";
import { GetRespondentFilterOptionsRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/getRespondentFilterOptionsRPCClientImpl";
import { ValidateUniqueColumnAndUpdateRespondentRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/validateUniqueColumnAndUpdateRespondentRPCClientImpl";
import { InsertDocumentRecordRPCClientImpl } from "@pulse/pulse-rpcs/lib/document/insertDocumentRecordRPCClientImpl";
import { GetPresignedDownloadURLForRespondentTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDownloadUrlForRespondentTemplateRPCClientImpl";
import { GetProjectSurveyResultsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getProjectSurveyResultsRPCClientImpl";
import { UnassignSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/unassignSurveyRPCClientImpl";
import { GetProjectSurveyNamesRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getProjectSurveyNamesRPCClientImpl";
import { RequestSurveyReportRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/requestSurveyReportRPCClientImpl";
import { CreateNewSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/createNewSurveyRPCClientImpl";
import { EditRespondentDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/editRespondentDetailsRPCClientImpl";
import { AssignSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/assignSurveyRPCClientImpl";
import { DeleteColumnRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/deleteColumnRPCClientImpl";
import { DeleteRespondentRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/deleteRespondentRPCClientImpl";
import { GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDownloadUrlForRespondentsWithFiltersForRespondentModuleRPCClientImpl";
import { GetAllActiveProjectsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getAllActiveProjectsRPCClientImpl";
import { GetAllArchivedProjectsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getAllArchivedProjectsRPCClientImpl";
import { CreateNewProjectRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/createNewProjectRPCClientImpl";
import { ArchiveProjectRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/archiveProjectRPCClientImpl";
import { GetProjectSpocDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getProjectSpocDetailsRPCClientImpl";
import { AssignSpocsToRespondentsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/assignSpocsToRespondentsRPCClientImpl";
import { GetProjectSpocsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getProjectSpocsRPCClientImpl";
import { GetArchivedSpocProjectsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getArchivedSpocProjectsRPCClientImpl";
import { GetActiveSpocProjectsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getActiveSpocProjectsRPCClientImpl";
import { AddSpocToProjectRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/addSpocToProjectRPCClientImpl";
import { GetSpocDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getSpocDetailsRPCClientImpl";
import { UnassignRespondentFromSpocRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/unassignRespondentFromSpocRPCClientImpl";
import { ResetSpocPasswordRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/resetSpocPasswordRPCClientImpl";
import { ChangeSpocPasswordRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/changeSpocPasswordRPCClientImpl";
import { DeleteProjectSpocsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/deleteProjectSpocsRPCClientImpl";
import { GetRespondentSpocsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getRespondentSpocsRPCClientImpl";
import { GetProjectBOUsersRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getProjectBoUsersRPCClientImpl";
import { GetBOUserDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/getBoUserDetailsRPCClientImpl";
import { AddBOUserToProjectRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/addBoUserToProjectRPCClientImpl";
import { UpdateProjectDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/updateProjectDetailsRPCClientImpl";
import { DeleteProjectBOUsersRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/deleteProjectBoUsersRPCClientImpl";
import { CloneSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/cloneSurveyRPCClientImpl";
import { CloneProjectRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/cloneProjectRPCClientImpl";
import { GetRespondentColumnNamesRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getRespondentColumnNamesRPCClientImpl";
import { GetPivotTableDataRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getPivotTableDataRPCClientImpl";
import { GetActiveResearcherProjectsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getActiveResearcherProjectsRPCClientImpl";
import { GetArchivedResearcherProjectsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getArchivedResearcherProjectsRPCClientImpl";
import { GetIndividualSubmittedResponsesRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/getIndividualSubmittedResponsesRPCClientImpl";
import { GetPresignedDownloadURLForIndividualSubmittedResponsesRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDownloadUrlForIndividualSubmittedResponsesRPCClientImpl";
import { UpdateSpocNameAndSettingsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/updateSpocNameAndSettingsRPCClientImpl";
import { APIClient } from "@surya-digital/tedwig";
import { MOCK } from "@pulse/shared-components";
import { MockGetRespondentDetailsClientImpl } from "./MockGetRespondentDetails";
import { MockGetRespondentFilterOptionsRPCClientImpl } from "./MockGetRespondentFilterOptionsRPCClientImpl";
import { MockGetPresignedDocumentUploadURLForRespondentsClientImpl } from "./MockGetPresignedDocumentUploadURLForRespondents";
import { MockValidateUniqueColumnAndUpdateRespondentClientImpl } from "./MockValidateUniqueColumnAndUpdateRespondent";
import { MockInsertDocumentRecordClientImpl } from "./MockInsertDocumentRecord";
import { MockGetPresignedDownloadURLForRespondentTemplateClientImpl } from "./MockGetPresignedDownloadURLForRespondentTemplate";
import { MockGetProjectSurveyResultsClientImpl } from "./MockGetProjectSurveyResultsClientImpl";
import { MockUnassignSurveyRPCClientImpl } from "./MockUnassignSurveyRPCClientImpl";
import { MockGetProjectSurveyNamesRPCClientImpl } from "./MockGetProjectSurveyNames";
import { MockRequestSurveyReportRPCClientImpl } from "./MockRequestSurveyReportRPCClientImpl";
import { MockCreateNewSurveyClientImpl } from "./MockCreateNewSurveyClientImpl";
import { MockEditRespondentDetailsClientImpl } from "./MockEditRespondentDetailsClientImpl";
import { MockAssignSurveyRPCClientImpl } from "./MockAssignSurvey";
import { MockDeleteColumnRPCClientImpl } from "./MockDeleteColumn";
import { MockDeleteRespondentRPCClientImpl } from "./MockDeleteRespondent";
import { MockGetPresignedDownloadURLForRespondentsWithFiltersClientImpl } from "./MockGetPresignedDownloadURLForRespondentsWithFilters";
import { MockGetAllActiveProjectsRPCClientImpl } from "./MockGetAllActiveProjectsRPCClientImpl";
import { MockGetAllArchivedProjectsRPCClientImpl } from "./MockGetAllArchivedProjectsRPCClientImpl";
import { MockCreateNewProjectRPCClientImpl } from "./MockCreateNewProjectRPCClientImpl";
import { MockArchiveProjectRPCClientImpl } from "./MockArchiveProjectRPCClientImpl";
import { MockGetProjectSpocDetailsRPCClientImpl } from "./MockGetProjectSpocDetailsRPCClientImpl";
import { MockAssignSpocsToRespondentsRPCClientImpl } from "./MockAssignSpocsToRespondentsRPCClientImpl";
import { MockGetProjectSpocsRPCClientImpl } from "./MockGetProjectSpocsRPCClientImpl";
import { MockGetArchivedSpocProjectsRPCClienImpl } from "./MockGetArchivedSpocProjectsRPCClientImpl";
import { MockGetActiveSpocProjectsRPCClientImpl } from "./MockGetActiveSpocProjectsRPCClientImpl";
import { MockAddSpocToProjectRPCClientImpl } from "./MockAddSpocToProjectRPCClientImpl";
import { MockGetSpocDetailsRPCClientImpl } from "./MockGetSpocDetailsRPCClientImpl";
import { MockUnassignRespondentFromSpocRPCClientImpl } from "./MockUnassignRespondentFromSpocRPCClientImpl";
import { MockUpdateSpocNameAndSettingsRPCClientImpl } from "./MockUpdateSpocNameAndSettingsRPCClientImpl";
import { MockResetSpocPasswordRPCClientImpl } from "./MockResetSpocPasswordRPCClientImpl";
import { MockChangeSpocPasswordRPCClientImpl } from "./MockChangeSpocPasswordRPCClientImpl";
import { MockDeleteProjectSpocsRPCClientImpl } from "./MockDeleteProjectSpocsRPCClientImpl";
import { MockGetRespondentSpocsRPCClientImpl } from "./MockGetRespondentSpocsRPCClientImpl";
import { MockGetProjectBOUsersRPCClientImpl } from "./MockGetProjectBOUsersRPCClientImpl";
import { ReopenSurveyLinksRPCClientImpl } from "@pulse/pulse-rpcs/lib/respondent/reopenSurveyLinksRPCClientImpl";
import { MockReopenSurveyLinksRPCClientImpl } from "./MockReopenSurveyLinksRPCClientImpl";
import { MockGetBOUserDetailsRPCClientImpl } from "./MockGetBOUserDetailsRPCClientImpl";
import { MockAddBOUserToProjectRPCClientImpl } from "./MockAddBOUserToProjectRPCClientImpl";
import { MockUpdateProjectDetailsRPCClientImpl } from "./MockUpdateProjectDetailsRPCClientImpl";
import { MockDeleteProjectBOUsersRPCClientImpl } from "./MockDeleteProjectBOUsersRPCClientImpl";
import { MockCloneSurveyRPCClientImpl } from "./MockCloneSurveyRPCClient";
import { MockCloneProjectProjectRPCClientImpl } from "./MockCloneProjectProjectRPCClientImpl";
import { MockGetRespondentColumnNamesRPCClientImpl } from "./MockGetRespondentColumnNamesRPCClientImpl";
import { MockGetPivotTableDataRPCClientImpl } from "./MockGetPivotTableDataRPCClientImpl";
import { MockGetActiveResearcherProjectsRPCClientImpl } from "./MockGetActiveResearcherProjectsRPCClientImpl";
import { MockGetArchivedResearcherProjectsRPCClientImpl } from "./MockGetArchivedResearcherProjectsRPCClientImpl";
import { MockGetProjectDetails } from "./MockGetProjectDetails";
import { GetProjectDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getProjectDetailsRPCClientImpl";
import { MockGetIndividualSubmittedResponsesRPCClientImpl } from "./MockGetIndividualSubmittedResponsesRPCClientImpl";
import { MockGetPresignedDownloadURLForIndividualSubmittedResponsesRPCClientImpl } from "./MockGetPresignedDownloadURLForIndividualSubmittedResponsesRPCClientImpl";
import { AddBOUserToProjectRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/addBoUserToProjectRPC";
import { DeleteProjectBOUsersRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/deleteProjectBoUsersRPC";
import { GetBOUserDetailsRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/getBoUserDetailsRPC";
import { InsertDocumentRecordRPC } from "@pulse/pulse-rpcs/lib/document/insertDocumentRecordRPC";
import { ArchiveProjectRPC } from "@pulse/pulse-rpcs/lib/project/archiveProjectRPC";
import { CloneProjectRPC } from "@pulse/pulse-rpcs/lib/project/cloneProjectRPC";
import { CreateNewProjectRPC } from "@pulse/pulse-rpcs/lib/project/createNewProjectRPC";
import { GetActiveResearcherProjectsRPC } from "@pulse/pulse-rpcs/lib/project/getActiveResearcherProjectsRPC";
import { GetActiveSpocProjectsRPC } from "@pulse/pulse-rpcs/lib/project/getActiveSpocProjectsRPC";
import { GetAllActiveProjectsRPC } from "@pulse/pulse-rpcs/lib/project/getAllActiveProjectsRPC";
import { GetAllArchivedProjectsRPC } from "@pulse/pulse-rpcs/lib/project/getAllArchivedProjectsRPC";
import { GetArchivedResearcherProjectsRPC } from "@pulse/pulse-rpcs/lib/project/getArchivedResearcherProjectsRPC";
import { GetArchivedSpocProjectsRPC } from "@pulse/pulse-rpcs/lib/project/getArchivedSpocProjectsRPC";
import { GetPivotTableDataRPC } from "@pulse/pulse-rpcs/lib/project/getPivotTableDataRPC";
import { GetProjectBOUsersRPC } from "@pulse/pulse-rpcs/lib/project/getProjectBoUsersRPC";
import { GetProjectDetailsRPC } from "@pulse/pulse-rpcs/lib/project/getProjectDetailsRPC";
import { GetProjectSurveyNamesRPC } from "@pulse/pulse-rpcs/lib/project/getProjectSurveyNamesRPC";
import { GetProjectSurveyResultsRPC } from "@pulse/pulse-rpcs/lib/project/getProjectSurveyResultsRPC";
import { GetRespondentColumnNamesRPC } from "@pulse/pulse-rpcs/lib/project/getRespondentColumnNamesRPC";
import { RequestSurveyReportRPC } from "@pulse/pulse-rpcs/lib/project/requestSurveyReportRPC";
import { UpdateProjectDetailsRPC } from "@pulse/pulse-rpcs/lib/project/updateProjectDetailsRPC";
import { AssignSurveyRPC } from "@pulse/pulse-rpcs/lib/respondent/assignSurveyRPC";
import { DeleteColumnRPC } from "@pulse/pulse-rpcs/lib/respondent/deleteColumnRPC";
import { DeleteRespondentRPC } from "@pulse/pulse-rpcs/lib/respondent/deleteRespondentRPC";
import { EditRespondentDetailsRPC } from "@pulse/pulse-rpcs/lib/respondent/editRespondentDetailsRPC";
import { GetIndividualSubmittedResponsesRPC } from "@pulse/pulse-rpcs/lib/respondent/getIndividualSubmittedResponsesRPC";
import { GetPresignedDocumentUploadURLForRespondentsRPC } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDocumentUploadUrlForRespondentsRPC";
import { GetPresignedDownloadURLForIndividualSubmittedResponsesRPC } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDownloadUrlForIndividualSubmittedResponsesRPC";
import { GetPresignedDownloadURLForRespondentTemplateRPC } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDownloadUrlForRespondentTemplateRPC";
import { GetRespondentDetailsRPC } from "@pulse/pulse-rpcs/lib/respondent/getRespondentDetailsRPC";
import { GetRespondentFilterOptionsRPC } from "@pulse/pulse-rpcs/lib/respondent/getRespondentFilterOptionsRPC";
import { ReopenSurveyLinksRPC } from "@pulse/pulse-rpcs/lib/respondent/reopenSurveyLinksRPC";
import { GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC } from "@pulse/pulse-rpcs/lib/respondent/getPresignedDownloadUrlForRespondentsWithFiltersForRespondentModuleRPC";
import { UnassignSurveyRPC } from "@pulse/pulse-rpcs/lib/respondent/unassignSurveyRPC";
import { ValidateUniqueColumnAndUpdateRespondentRPC } from "@pulse/pulse-rpcs/lib/respondent/validateUniqueColumnAndUpdateRespondentRPC";
import { AddSpocToProjectRPC } from "@pulse/pulse-rpcs/lib/spoc-management/addSpocToProjectRPC";
import { AssignSpocsToRespondentsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/assignSpocsToRespondentsRPC";
import { ChangeSpocPasswordRPC } from "@pulse/pulse-rpcs/lib/spoc-management/changeSpocPasswordRPC";
import { DeleteProjectSpocsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/deleteProjectSpocsRPC";
import { GetProjectSpocDetailsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getProjectSpocDetailsRPC";
import { GetProjectSpocsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getProjectSpocsRPC";
import { GetRespondentSpocsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getRespondentSpocsRPC";
import { GetSpocDetailsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getSpocDetailsRPC";
import { ResetSpocPasswordRPC } from "@pulse/pulse-rpcs/lib/spoc-management/resetSpocPasswordRPC";
import { UnassignRespondentFromSpocRPC } from "@pulse/pulse-rpcs/lib/spoc-management/unassignRespondentFromSpocRPC";
import { UpdateSpocNameAndSettingsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/updateSpocNameAndSettingsRPC";
import { CloneSurveyRPC } from "@pulse/pulse-rpcs/lib/survey/cloneSurveyRPC";
import { CreateNewSurveyRPC } from "@pulse/pulse-rpcs/lib/survey/createNewSurveyRPC";
import { GetPresignedDownloadURLForBulkSpocTemplateRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDownloadUrlForBulkSpocTemplateRPC";
import { GetPresignedDownloadURLForBulkSpocTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDownloadUrlForBulkSpocTemplateRPCClientImpl";
import { MockGetPresignedDownloadURLForBulkSpocTemplateRPCClientImpl } from "./MockGetPresignedDownloadURLForBulkSpocTemplateRPCClientImpl";
import { ValidateCSVAndUploadSpocsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/validateCsvAndUploadSpocsRPC";
import { ValidateCSVAndUploadSpocsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/validateCsvAndUploadSpocsRPCClientImpl";
import { MockValidateCSVAndUploadSpocsRPCClientImpl } from "./MockValidateCSVAndUploadSpocsRPCClientImpl";
import { MockGetPresignedUploadURLForSpocsRPCClientImpl } from "./MockGetPresignedUploadURLForSpocsRPCClientImpl";
import { GetPresignedUploadURLForSpocsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedUploadUrlForSpocsRPC";
import { GetPresignedUploadURLForSpocsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedUploadUrlForSpocsRPCClientImpl";
import { GetAddMultipleSpocsToProjectScheduleJobStatusRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getAddMultipleSpocsToProjectScheduleJobStatusRPC";
import { GetAddMultipleSpocsToProjectScheduleJobStatusRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getAddMultipleSpocsToProjectScheduleJobStatusRPCClientImpl";
import { MockGetAddMultipleSpocsToProjectScheduleJobStatusRPCClientImpl } from "./MockGetAddMultipleSpocsToProjectScheduleJobStatusRPCClientImpl";
import { ValidateCSVAndBulkAssignSpocsToRespondentsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/validateCsvAndBulkAssignSpocsToRespondentsRPCClientImpl";
import { ValidateCSVAndBulkAssignSpocsToRespondentsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/validateCsvAndBulkAssignSpocsToRespondentsRPC";
import { MockValidateCSVAndBulkAssignSpocsToRespondentsRPCClientImpl } from "./MockValidateCSVAndBulkAssignSpocsToRespondentsRPCClientImpl";
import { GetPresignedDocumentUploadURLForRespondentSpocMappingRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDocumentUploadUrlForRespondentSpocMappingRPC";
import { MockGetPresignedDocumentUploadURLForRespondentSpocMappingRPCClientImpl } from "./MockGetPresignedDocumentUploadURLForRespondentSpocMappingRPCClientImpl";
import { GetPresignedDocumentUploadURLForRespondentSpocMappingRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDocumentUploadUrlForRespondentSpocMappingRPCClientImpl";
import { GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDownloadUrlForRespondentSpocMappingTemplateRPC";
import { MockGetPresignedDownloadURLForRespondentSpocMappingTemplateRPCClientImpl } from "./MockGetPresignedDownloadURLForRespondentSpocMappingTemplateRPCClientImpl";
import { GetPresignedDownloadURLForRespondentSpocMappingTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDownloadUrlForRespondentSpocMappingTemplateRPCClientImpl";
import { GetPresignedDownloadURLForSpocsWithFiltersRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDownloadUrlForSpocsWithFiltersRPC";
import { MockGetPresignedDownloadURLForSpocsWithFiltersRPCClientImpl } from "./MockGetPresignedDownloadURLForSpocsWithFiltersRPCClientImpl";
import { GetPresignedDownloadURLForSpocsWithFiltersRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDownloadUrlForSpocsWithFiltersRPCClientImpl";
import { GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDocumentUploadUrlForSpocRespondentUnmappingRPC";
import { GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/getPresignedDocumentUploadUrlForSpocRespondentUnmappingRPCClientImpl";
import { MockGetPresignedDocumentUploadURLForSpocRespondentUnmappingRPCClientImpl } from "./MockGetPresignedDocumentUploadURLForSpocRespondentUnmappingRPCClientImpl";
import { MockValidateCSVAndUnmapRespondentsFromSpocsRPCClientImpl } from "./MockValidateCSVAndUnmapRespondentsFromSpocsRPCClientImpl";
import { ValidateCSVAndUnmapRespondentsFromSpocsRPC } from "@pulse/pulse-rpcs/lib/spoc-management/validateCsvAndUnmapRespondentsFromSpocsRPC";
import { ValidateCSVAndUnmapRespondentsFromSpocsRPCClientImpl } from "@pulse/pulse-rpcs/lib/spoc-management/validateCsvAndUnmapRespondentsFromSpocsRPCClientImpl";

export const useGetRespondentDetailsRPCClientImpl = (
  apiClient: APIClient,
): GetRespondentDetailsRPC => {
  if (MOCK.respondentDetails) {
    return new MockGetRespondentDetailsClientImpl();
  } else {
    return new GetRespondentDetailsRPCClientImpl(apiClient);
  }
};

export const useGetPresignedDocumentUploadURLForRespondentsRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedDocumentUploadURLForRespondentsRPC => {
  if (MOCK.respondentDetails) {
    return new MockGetPresignedDocumentUploadURLForRespondentsClientImpl();
  } else {
    return new GetPresignedDocumentUploadURLForRespondentsRPCClientImpl(
      apiClient,
    );
  }
};

export const useValidateUniqueColumnAndUpdateRespondentClientImpl = (
  apiClient: APIClient,
): ValidateUniqueColumnAndUpdateRespondentRPC => {
  if (MOCK.respondentDetails) {
    return new MockValidateUniqueColumnAndUpdateRespondentClientImpl();
  } else {
    return new ValidateUniqueColumnAndUpdateRespondentRPCClientImpl(apiClient);
  }
};

export const useInsertDocumentRecordRPCClientImpl = (
  apiClient: APIClient,
): InsertDocumentRecordRPC => {
  if (MOCK.respondentDetails) {
    return new MockInsertDocumentRecordClientImpl();
  }
  return new InsertDocumentRecordRPCClientImpl(apiClient);
};

export const useGetPresignedDownloadURLForRespondentTemplateRPCClient = (
  apiClient: APIClient,
): GetPresignedDownloadURLForRespondentTemplateRPC => {
  if (MOCK.respondentDetails) {
    return new MockGetPresignedDownloadURLForRespondentTemplateClientImpl();
  }
  return new GetPresignedDownloadURLForRespondentTemplateRPCClientImpl(
    apiClient,
  );
};

export const useGetProjectSurveyResultsRPCClient = (
  apiClient: APIClient,
): GetProjectSurveyResultsRPC => {
  if (MOCK.surveyResults) {
    return new MockGetProjectSurveyResultsClientImpl();
  }
  return new GetProjectSurveyResultsRPCClientImpl(apiClient);
};

export const useUnassignSurveyRPCClientImpl = (
  apiClient: APIClient,
): UnassignSurveyRPC => {
  if (MOCK.respondentDetails) {
    return new MockUnassignSurveyRPCClientImpl();
  } else {
    return new UnassignSurveyRPCClientImpl(apiClient);
  }
};

export const useGetProjectSurveyNamesRPCClientImpl = (
  apiClient: APIClient,
): GetProjectSurveyNamesRPC => {
  if (MOCK.reportDetails) {
    return new MockGetProjectSurveyNamesRPCClientImpl();
  }
  return new GetProjectSurveyNamesRPCClientImpl(apiClient);
};

export const useRequestSurveyReportRPCClientImpl = (
  apiClient: APIClient,
): RequestSurveyReportRPC => {
  if (MOCK.reportDetails) {
    return new MockRequestSurveyReportRPCClientImpl();
  }
  return new RequestSurveyReportRPCClientImpl(apiClient);
};

export const useCreateNewSurveyRPCClientImpl = (
  apiClient: APIClient,
): CreateNewSurveyRPC => {
  if (MOCK.survey) {
    return new MockCreateNewSurveyClientImpl();
  }
  return new CreateNewSurveyRPCClientImpl(apiClient);
};

export const useEditRespondentDetailsRPCClientImpl = (
  apiClient: APIClient,
): EditRespondentDetailsRPC => {
  if (MOCK.survey) {
    return new MockEditRespondentDetailsClientImpl();
  }
  return new EditRespondentDetailsRPCClientImpl(apiClient);
};

export const useAssignSurveyRPCClientImpl = (
  apiClient: APIClient,
): AssignSurveyRPC => {
  if (MOCK.respondentDetails) {
    return new MockAssignSurveyRPCClientImpl();
  }
  return new AssignSurveyRPCClientImpl(apiClient);
};

export const useDeleteColumnRPCClientImpl = (
  apiClient: APIClient,
): DeleteColumnRPC => {
  if (MOCK.respondentDetails) {
    return new MockDeleteColumnRPCClientImpl();
  }
  return new DeleteColumnRPCClientImpl(apiClient);
};

export const useDeleteRespondentRPCClientImpl = (
  apiClient: APIClient,
): DeleteRespondentRPC => {
  if (MOCK.respondentDetails) {
    return new MockDeleteRespondentRPCClientImpl();
  }
  return new DeleteRespondentRPCClientImpl(apiClient);
};

export const useGetPresignedDownloadURLForRespondentsWithFiltersRPCClient = (
  apiClient: APIClient,
): GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPC => {
  if (MOCK.respondentDetails) {
    return new MockGetPresignedDownloadURLForRespondentsWithFiltersClientImpl();
  }
  return new GetPresignedDownloadURLForRespondentsWithFiltersForRespondentModuleRPCClientImpl(
    apiClient,
  );
};

export const useGetAllActiveProjectsRPCClient = (
  apiClient: APIClient,
): GetAllActiveProjectsRPC => {
  if (MOCK.projectList) {
    return new MockGetAllActiveProjectsRPCClientImpl();
  } else {
    return new GetAllActiveProjectsRPCClientImpl(apiClient);
  }
};

export const useGetActiveResearcherProjectsRPCClient = (
  apiClient: APIClient,
): GetActiveResearcherProjectsRPC => {
  if (MOCK.projectList) {
    return new MockGetActiveResearcherProjectsRPCClientImpl();
  } else {
    return new GetActiveResearcherProjectsRPCClientImpl(apiClient);
  }
};

export const useGetProjectSpocsRPCClient = (
  apiClient: APIClient,
): GetProjectSpocsRPC => {
  if (MOCK.userAccess) {
    return new MockGetProjectSpocsRPCClientImpl();
  } else {
    return new GetProjectSpocsRPCClientImpl(apiClient);
  }
};

export const useGetActiveSpocProjectsRPCClient = (
  apiClient: APIClient,
): GetActiveSpocProjectsRPC => {
  if (MOCK.projectList) {
    return new MockGetActiveSpocProjectsRPCClientImpl();
  } else {
    return new GetActiveSpocProjectsRPCClientImpl(apiClient);
  }
};

export const useGetArchivedSpocProjectsRPCClient = (
  apiClient: APIClient,
): GetArchivedSpocProjectsRPC => {
  if (MOCK.projectList) {
    return new MockGetArchivedSpocProjectsRPCClienImpl();
  } else {
    return new GetArchivedSpocProjectsRPCClientImpl(apiClient);
  }
};

export const useGetAllArchivedProjectsRPCClient = (
  apiClient: APIClient,
): GetAllArchivedProjectsRPC => {
  if (MOCK.projectList) {
    return new MockGetAllArchivedProjectsRPCClientImpl();
  } else {
    return new GetAllArchivedProjectsRPCClientImpl(apiClient);
  }
};

export const useGetArchivedResearcherProjectsRPCClient = (
  apiClient: APIClient,
): GetArchivedResearcherProjectsRPC => {
  if (MOCK.projectList) {
    return new MockGetArchivedResearcherProjectsRPCClientImpl();
  } else {
    return new GetArchivedResearcherProjectsRPCClientImpl(apiClient);
  }
};

export const useCreateNewProjectRPCClientImpl = (
  apiClient: APIClient,
): CreateNewProjectRPC => {
  if (MOCK.projectList) {
    return new MockCreateNewProjectRPCClientImpl();
  } else {
    return new CreateNewProjectRPCClientImpl(apiClient);
  }
};

export const useCloneProjectRPCClientImpl = (
  apiClient: APIClient,
): CloneProjectRPC => {
  if (MOCK.projectList) {
    return new MockCloneProjectProjectRPCClientImpl();
  } else {
    return new CloneProjectRPCClientImpl(apiClient);
  }
};

export const useArchiveProjectRPCClientImpl = (
  apiClient: APIClient,
): ArchiveProjectRPC => {
  if (MOCK.projectList) {
    return new MockArchiveProjectRPCClientImpl();
  } else {
    return new ArchiveProjectRPCClientImpl(apiClient);
  }
};

export const useGetProjectSpocDetailsRPCClientImpl = (
  apiClient: APIClient,
): GetProjectSpocDetailsRPC => {
  if (MOCK.spocManagement) {
    return new MockGetProjectSpocDetailsRPCClientImpl();
  } else {
    return new GetProjectSpocDetailsRPCClientImpl(apiClient);
  }
};

export const useGetRespondentSpocsRPCClientImpl = (
  apiClient: APIClient,
): GetRespondentSpocsRPC => {
  if (MOCK.spocManagement) {
    return new MockGetRespondentSpocsRPCClientImpl();
  } else {
    return new GetRespondentSpocsRPCClientImpl(apiClient);
  }
};

export const useAssignSpocsToRespondentsRPCClientImpl = (
  apiClient: APIClient,
): AssignSpocsToRespondentsRPC => {
  if (MOCK.spocManagement) {
    return new MockAssignSpocsToRespondentsRPCClientImpl();
  } else {
    return new AssignSpocsToRespondentsRPCClientImpl(apiClient);
  }
};

export const useAddSpocToProjectRPCClientImpl = (
  apiClient: APIClient,
): AddSpocToProjectRPC => {
  if (MOCK.userAccess) {
    return new MockAddSpocToProjectRPCClientImpl();
  } else {
    return new AddSpocToProjectRPCClientImpl(apiClient);
  }
};

export const useGetSpocDetailsRPCClient = (
  apiClient: APIClient,
): GetSpocDetailsRPC => {
  if (MOCK.userAccess) {
    return new MockGetSpocDetailsRPCClientImpl();
  } else {
    return new GetSpocDetailsRPCClientImpl(apiClient);
  }
};

export const useUpdateSpocNameAndSettingsRPCClient = (
  apiClient: APIClient,
): UpdateSpocNameAndSettingsRPC => {
  if (MOCK.userAccess) {
    return new MockUpdateSpocNameAndSettingsRPCClientImpl();
  } else {
    return new UpdateSpocNameAndSettingsRPCClientImpl(apiClient);
  }
};

export const useResetSpocPasswordRPCClient = (
  apiClient: APIClient,
): ResetSpocPasswordRPC => {
  if (MOCK.userAccess) {
    return new MockResetSpocPasswordRPCClientImpl();
  } else {
    return new ResetSpocPasswordRPCClientImpl(apiClient);
  }
};

export const useChangeSpocPasswordRPCClient = (
  apiClient: APIClient,
): ChangeSpocPasswordRPC => {
  if (MOCK.userAccess) {
    return new MockChangeSpocPasswordRPCClientImpl();
  } else {
    return new ChangeSpocPasswordRPCClientImpl(apiClient);
  }
};

export const useDeleteProjectSpocsRPCClient = (
  apiClient: APIClient,
): DeleteProjectSpocsRPC => {
  if (MOCK.userAccess) {
    return new MockDeleteProjectSpocsRPCClientImpl();
  } else {
    return new DeleteProjectSpocsRPCClientImpl(apiClient);
  }
};

export const useUnassignRespondentFromSpocRPCClientImpl = (
  apiClient: APIClient,
): UnassignRespondentFromSpocRPC => {
  if (MOCK.userAccess) {
    return new MockUnassignRespondentFromSpocRPCClientImpl();
  } else {
    return new UnassignRespondentFromSpocRPCClientImpl(apiClient);
  }
};

export const useGetProjectBOUsersRPCClient = (
  apiClient: APIClient,
): GetProjectBOUsersRPC => {
  if (MOCK.userAccess) {
    return new MockGetProjectBOUsersRPCClientImpl();
  } else {
    return new GetProjectBOUsersRPCClientImpl(apiClient);
  }
};

export const useReopenSurveyLinksRPCClientImpl = (
  apiClient: APIClient,
): ReopenSurveyLinksRPC => {
  if (MOCK.surveyRespondent) {
    return new MockReopenSurveyLinksRPCClientImpl();
  } else {
    return new ReopenSurveyLinksRPCClientImpl(apiClient);
  }
};

export const useGetBOUserDetailsRPCClient = (
  apiClient: APIClient,
): GetBOUserDetailsRPC => {
  if (MOCK.userAccess) {
    return new MockGetBOUserDetailsRPCClientImpl();
  }
  return new GetBOUserDetailsRPCClientImpl(apiClient);
};

export const useAddBOUserToProjectRPCClient = (
  apiClient: APIClient,
): AddBOUserToProjectRPC => {
  if (MOCK.userAccess) {
    return new MockAddBOUserToProjectRPCClientImpl();
  }
  return new AddBOUserToProjectRPCClientImpl(apiClient);
};

export const useUpdateProjectDetailsRPCClient = (
  apiClient: APIClient,
): UpdateProjectDetailsRPC => {
  if (MOCK.projectList) {
    return new MockUpdateProjectDetailsRPCClientImpl();
  }
  return new UpdateProjectDetailsRPCClientImpl(apiClient);
};

export const useGetProjectDetailsClientImpl = (
  apiClient: APIClient,
): GetProjectDetailsRPC => {
  if (MOCK.projectList) {
    return new MockGetProjectDetails();
  } else {
    return new GetProjectDetailsRPCClientImpl(apiClient);
  }
};

export const useDeleteProjectBOUsersRPCClientImpl = (
  apiClient: APIClient,
): DeleteProjectBOUsersRPC => {
  if (MOCK.userAccess) {
    return new MockDeleteProjectBOUsersRPCClientImpl();
  } else {
    return new DeleteProjectBOUsersRPCClientImpl(apiClient);
  }
};

export const useCloneSurveyRPCClientImpl = (
  apiClient: APIClient,
): CloneSurveyRPC => {
  if (MOCK.survey) {
    return new MockCloneSurveyRPCClientImpl();
  } else {
    return new CloneSurveyRPCClientImpl(apiClient);
  }
};

export const useGetRespondentColumnNamesRPCClientImpl = (
  apiClient: APIClient,
): GetRespondentColumnNamesRPC => {
  if (MOCK.surveyResults) {
    return new MockGetRespondentColumnNamesRPCClientImpl();
  } else {
    return new GetRespondentColumnNamesRPCClientImpl(apiClient);
  }
};

export const useGetPivotTableDataRPCClientImpl = (
  apiClient: APIClient,
): GetPivotTableDataRPC => {
  if (MOCK.surveyResults) {
    return new MockGetPivotTableDataRPCClientImpl();
  } else {
    return new GetPivotTableDataRPCClientImpl(apiClient);
  }
};

export const useGetIndividualSubmittedResponsesRPCClientImpl = (
  apiClient: APIClient,
): GetIndividualSubmittedResponsesRPC => {
  if (MOCK.surveyResults) {
    return new MockGetIndividualSubmittedResponsesRPCClientImpl();
  } else {
    return new GetIndividualSubmittedResponsesRPCClientImpl(apiClient);
  }
};

export const useGetPresignedDownloadURLForIndividualSubmittedResponsesRPCClientImpl =
  (
    apiClient: APIClient,
  ): GetPresignedDownloadURLForIndividualSubmittedResponsesRPC => {
    if (MOCK.surveyResults) {
      return new MockGetPresignedDownloadURLForIndividualSubmittedResponsesRPCClientImpl();
    } else {
      return new GetPresignedDownloadURLForIndividualSubmittedResponsesRPCClientImpl(
        apiClient,
      );
    }
  };

export const useGetPresignedDownloadURLForBulkSpocTemplateRPCClient = (
  apiClient: APIClient,
): GetPresignedDownloadURLForBulkSpocTemplateRPC => {
  if (MOCK.surveyResults) {
    return new MockGetPresignedDownloadURLForBulkSpocTemplateRPCClientImpl();
  } else {
    return new GetPresignedDownloadURLForBulkSpocTemplateRPCClientImpl(
      apiClient,
    );
  }
};

export const useGetPresignedUploadURLForSpocsRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedUploadURLForSpocsRPC => {
  if (MOCK.surveyResults) {
    return new MockGetPresignedUploadURLForSpocsRPCClientImpl();
  } else {
    return new GetPresignedUploadURLForSpocsRPCClientImpl(apiClient);
  }
};

export const useValidateCSVAndUploadSpocsRPCClient = (
  apiClient: APIClient,
): ValidateCSVAndUploadSpocsRPC => {
  if (MOCK.surveyResults) {
    return new MockValidateCSVAndUploadSpocsRPCClientImpl();
  } else {
    return new ValidateCSVAndUploadSpocsRPCClientImpl(apiClient);
  }
};

export const useGetAddMultipleSpocsToProjectScheduleJobStatusRPCClient = (
  apiClient: APIClient,
): GetAddMultipleSpocsToProjectScheduleJobStatusRPC => {
  if (MOCK.surveyResults) {
    return new MockGetAddMultipleSpocsToProjectScheduleJobStatusRPCClientImpl();
  } else {
    return new GetAddMultipleSpocsToProjectScheduleJobStatusRPCClientImpl(
      apiClient,
    );
  }
};

export const useValidateCSVAndBulkAssignSpocsToRespondentsRPCClientImpl = (
  apiClient: APIClient,
): ValidateCSVAndBulkAssignSpocsToRespondentsRPC => {
  if (MOCK.surveyResults) {
    return new MockValidateCSVAndBulkAssignSpocsToRespondentsRPCClientImpl();
  } else {
    return new ValidateCSVAndBulkAssignSpocsToRespondentsRPCClientImpl(
      apiClient,
    );
  }
};

export const useGetPresignedDocumentUploadURLForRespondentSpocMappingRPCClientImpl =
  (
    apiClient: APIClient,
  ): GetPresignedDocumentUploadURLForRespondentSpocMappingRPC => {
    if (MOCK.surveyResults) {
      return new MockGetPresignedDocumentUploadURLForRespondentSpocMappingRPCClientImpl();
    } else {
      return new GetPresignedDocumentUploadURLForRespondentSpocMappingRPCClientImpl(
        apiClient,
      );
    }
  };

export const useGetPresignedDownloadURLForRespondentSpocMappingTemplateRPCClientImpl =
  (
    apiClient: APIClient,
  ): GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC => {
    if (MOCK.surveyResults) {
      return new MockGetPresignedDownloadURLForRespondentSpocMappingTemplateRPCClientImpl();
    } else {
      return new GetPresignedDownloadURLForRespondentSpocMappingTemplateRPCClientImpl(
        apiClient,
      );
    }
  };

export const useGetPresignedDownloadURLForSPoCsWithFiltersRPCClient = (
  apiClient: APIClient,
): GetPresignedDownloadURLForSpocsWithFiltersRPC => {
  if (MOCK.surveyResults) {
    return new MockGetPresignedDownloadURLForSpocsWithFiltersRPCClientImpl();
  } else {
    return new GetPresignedDownloadURLForSpocsWithFiltersRPCClientImpl(
      apiClient,
    );
  }
};

export const useGetPresignedUploadURLForSpocRespondentUnmappingRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC => {
  if (MOCK.surveyResults) {
    return new MockGetPresignedDocumentUploadURLForSpocRespondentUnmappingRPCClientImpl();
  } else {
    return new GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPCClientImpl(
      apiClient,
    );
  }
};

export const useValidateCSVAndUnmapRespondentsFromSpocsRPCClientImpl = (
  apiClient: APIClient,
): ValidateCSVAndUnmapRespondentsFromSpocsRPC => {
  if (MOCK.surveyResults) {
    return new MockValidateCSVAndUnmapRespondentsFromSpocsRPCClientImpl();
  } else {
    return new ValidateCSVAndUnmapRespondentsFromSpocsRPCClientImpl(apiClient);
  }
};

export const useGetRespondentFilterOptionsRPCClientImpl = (
  apiClient: APIClient,
): GetRespondentFilterOptionsRPC => {
  if (MOCK.respondentDetails) {
    return new MockGetRespondentFilterOptionsRPCClientImpl();
  }
  return new GetRespondentFilterOptionsRPCClientImpl(apiClient);
};
